export default "__VITE_ASSET__DcCXT2Hq__"